<template>
  <div class="overall">
      <img v-for="(item,index) in url" :key="index" :src="item" alt="">
  </div>
</template>

<script>
export default {
data(){
    return{
        url:[]
    }
},
created(){
  this.url=this.$route.query.url.split(',')
}
}
</script>

<style lang="scss" scoped>
.overall{
    width: 1200px;
    margin: 0 auto;
    height: auto;
    img{
        width: 100%;
        margin-top: 20px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/pngView/index.vue